import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import styles from "./styles.module.css";
import { useState } from "react";
import { NumericFormat } from "react-number-format";
import InputCurrency from "../../../components/Campo/InputCurrency";

const ExecucaoReceitaDespesa = () => {
  //Receita
  const [receitaParcelaAnteriorTermo, setReceitaParcelaAnteriorTermo] =
    useState(0);
  const [receitaParcelaAtualTermo, setReceitaParcelaAtualTermo] = useState(0);

  const [
    receitaParcelaAnteriorContrapartida,
    setReceitaParcelaAnteriorContrapartida,
  ] = useState(0);
  const [
    receitaParcelaAtualContrapartida,
    setReceitaParcelaAtualContrapartida,
  ] = useState(0);

  const [receitaParcelaAnteriorProprio, setReceitaParcelaAnteriorProprio] =
    useState(0);
  const [receitaParcelaAtualProprio, setReceitaParcelaAtualProprio] =
    useState(0);

  const [receitaParcelaAnteriorResultado, setReceitaParcelaAnteriorResultado] =
    useState(0);
  const [receitaParcelaAtualResultado, setReceitaParcelaAtualResultado] =
    useState(0);

  const [receitaParcelaAnteriorOutras, setReceitaParcelaAnteriorOutras] =
    useState(0);
  const [receitaParcelaAtualOutras, setReceitaParcelaAtualOutras] = useState(0);

  //Despesa
  const [despesaParcelaAnteriorTermo, setDespesaParcelaAnteriorTermo] =
    useState(0);
  const [despesaParcelaAtualTermo, setDespesaParcelaAtualTermo] = useState(0);

  const [
    despesaParcelaAnteriorContrapartida,
    setDespesaParcelaAnteriorContrapartida,
  ] = useState(0);
  const [
    despesaParcelaAtualContrapartida,
    setDespesaParcelaAtualContrapartida,
  ] = useState(0);

  const [despesaParcelaAnteriorProprio, setDespesaParcelaAnteriorProprio] =
    useState(0);
  const [despesaParcelaAtualProprio, setDespesaParcelaAtualProprio] =
    useState(0);

  const [despesaParcelaAnteriorResultado, setDespesaParcelaAnteriorResultado] =
    useState(0);
  const [despesaParcelaAtualResultado, setDespesaParcelaAtualResultado] =
    useState(0);

  const [despesaParcelaAnteriorOutras, setDespesaParcelaAnteriorOutras] =
    useState(0);
  const [despesaParcelaAtualOutras, setDespesaParcelaAtualOutras] = useState(0);

  return (
    <form className={styles.formCadastro} onSubmit={(e) => e.preventDefault()}>
      <div>
        <h2 className={styles.titulo}>
          3. Demonstrativo da Execução da <strong>Receita</strong> e{" "}
          <strong>Despesa</strong>
        </h2>
        <div className={styles.table}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell rowSpan={2} align="center">
                    ESPECIFICAÇÃO
                  </TableCell>
                  <TableCell colSpan={3} align="center">
                    RECEITA
                  </TableCell>
                  <TableCell colSpan={3} align="center">
                    DESPESA
                  </TableCell>
                  <TableCell rowSpan={2} align="center">
                    SALDOS
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>PARCELAS ANTERIORES</TableCell>
                  <TableCell>PARCELA ATUAL</TableCell>
                  <TableCell>TOTAL ACUMULADO</TableCell>
                  <TableCell>PARCELAS ANTERIORES</TableCell>
                  <TableCell>PARCELA ATUAL</TableCell>
                  <TableCell>TOTAL ACUMULADO</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="center">
                    <strong>RECURSOS DE TERMO</strong>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAnteriorTermo}
                      setter={setReceitaParcelaAnteriorTermo}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAtualTermo}
                      setter={setReceitaParcelaAtualTermo}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorTermo +
                          receitaParcelaAtualTermo || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAnteriorTermo}
                      setter={setDespesaParcelaAnteriorTermo}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAtualTermo}
                      setter={setDespesaParcelaAtualTermo}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        despesaParcelaAnteriorTermo +
                          despesaParcelaAtualTermo || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorTermo +
                          receitaParcelaAtualTermo -
                          (despesaParcelaAnteriorTermo +
                            despesaParcelaAtualTermo) || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">
                    <strong>RECURSOS DA CONTRAPARTIDA</strong>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAnteriorContrapartida}
                      setter={setReceitaParcelaAnteriorContrapartida}
                    />
                  </TableCell>

                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAtualContrapartida}
                      setter={setReceitaParcelaAtualContrapartida}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorContrapartida +
                          receitaParcelaAtualContrapartida || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAnteriorContrapartida}
                      setter={setDespesaParcelaAnteriorContrapartida}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAtualContrapartida}
                      setter={setDespesaParcelaAtualContrapartida}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        despesaParcelaAnteriorContrapartida +
                          despesaParcelaAtualContrapartida || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorContrapartida +
                          receitaParcelaAtualContrapartida -
                          (despesaParcelaAnteriorContrapartida +
                            despesaParcelaAtualContrapartida) || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">
                    <strong>RECURSOS PRÓPRIOS</strong>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAnteriorProprio}
                      setter={setReceitaParcelaAnteriorProprio}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAtualProprio}
                      setter={setReceitaParcelaAtualProprio}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorProprio +
                          receitaParcelaAtualProprio || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAnteriorProprio}
                      setter={setDespesaParcelaAnteriorProprio}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAtualProprio}
                      setter={setDespesaParcelaAtualProprio}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        despesaParcelaAnteriorProprio +
                          despesaParcelaAtualProprio || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorProprio +
                          receitaParcelaAtualProprio -
                          (despesaParcelaAnteriorProprio +
                            despesaParcelaAtualProprio) || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">
                    <strong>
                      RECURSOS DO RESULTADO DA APLICAÇÃO FINANCEIRA
                    </strong>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAnteriorResultado}
                      setter={setReceitaParcelaAnteriorResultado}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAtualResultado}
                      setter={setReceitaParcelaAtualResultado}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorResultado +
                          receitaParcelaAtualResultado || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAnteriorResultado}
                      setter={setDespesaParcelaAnteriorResultado}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAtualResultado}
                      setter={setDespesaParcelaAtualResultado}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        despesaParcelaAnteriorResultado +
                          despesaParcelaAtualResultado || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorResultado +
                          receitaParcelaAtualResultado -
                          (despesaParcelaAnteriorResultado +
                            despesaParcelaAtualResultado) || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">
                    <strong>OUTRAS (Tarifas Bancarias)</strong>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAnteriorOutras}
                      setter={setReceitaParcelaAnteriorOutras}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={receitaParcelaAtualOutras}
                      setter={setReceitaParcelaAtualOutras}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorOutras +
                          receitaParcelaAtualOutras || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAnteriorOutras}
                      setter={setDespesaParcelaAnteriorOutras}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCurrency
                      value={despesaParcelaAtualOutras}
                      setter={setDespesaParcelaAtualOutras}
                    />
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        despesaParcelaAnteriorOutras +
                          despesaParcelaAtualOutras || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span>
                      R$
                      {(
                        receitaParcelaAnteriorOutras +
                          receitaParcelaAtualOutras -
                          (despesaParcelaAnteriorOutras +
                            despesaParcelaAtualOutras) || 0
                      ).toFixed(2)}
                    </span>
                  </TableCell>
                </TableRow>
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell align="center">TOTAL</TableCell>
                  <TableCell>
                    R$
                    {(
                      receitaParcelaAnteriorTermo +
                      receitaParcelaAnteriorContrapartida +
                      receitaParcelaAnteriorProprio +
                      receitaParcelaAnteriorResultado +
                      receitaParcelaAnteriorOutras
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    R$
                    {(
                      receitaParcelaAtualTermo +
                      receitaParcelaAtualContrapartida +
                      receitaParcelaAtualProprio +
                      receitaParcelaAtualResultado +
                      receitaParcelaAtualOutras
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    R$
                    {(
                      receitaParcelaAnteriorTermo +
                      receitaParcelaAnteriorContrapartida +
                      receitaParcelaAnteriorProprio +
                      receitaParcelaAnteriorResultado +
                      receitaParcelaAnteriorOutras +
                      receitaParcelaAtualTermo +
                      receitaParcelaAtualContrapartida +
                      receitaParcelaAtualProprio +
                      receitaParcelaAtualResultado +
                      receitaParcelaAtualOutras
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    R$
                    {(
                      despesaParcelaAnteriorTermo +
                      despesaParcelaAnteriorContrapartida +
                      despesaParcelaAnteriorProprio +
                      despesaParcelaAnteriorResultado +
                      despesaParcelaAnteriorOutras
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    R$
                    {(
                      despesaParcelaAtualTermo +
                      despesaParcelaAtualContrapartida +
                      despesaParcelaAtualProprio +
                      despesaParcelaAtualResultado +
                      despesaParcelaAtualOutras
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    R$
                    {(
                      despesaParcelaAnteriorTermo +
                      despesaParcelaAnteriorContrapartida +
                      despesaParcelaAnteriorProprio +
                      despesaParcelaAnteriorResultado +
                      despesaParcelaAnteriorOutras +
                      despesaParcelaAtualTermo +
                      despesaParcelaAtualContrapartida +
                      despesaParcelaAtualProprio +
                      despesaParcelaAtualResultado +
                      despesaParcelaAtualOutras
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    R$
                    {(
                      receitaParcelaAnteriorTermo +
                      receitaParcelaAnteriorContrapartida +
                      receitaParcelaAnteriorProprio +
                      receitaParcelaAnteriorResultado +
                      receitaParcelaAnteriorOutras +
                      receitaParcelaAtualTermo +
                      receitaParcelaAtualContrapartida +
                      receitaParcelaAtualProprio +
                      receitaParcelaAtualResultado +
                      receitaParcelaAtualOutras -
                      (despesaParcelaAnteriorTermo +
                        despesaParcelaAnteriorContrapartida +
                        despesaParcelaAnteriorProprio +
                        despesaParcelaAnteriorResultado +
                        despesaParcelaAnteriorOutras +
                        despesaParcelaAtualTermo +
                        despesaParcelaAtualContrapartida +
                        despesaParcelaAtualProprio +
                        despesaParcelaAtualResultado +
                        despesaParcelaAtualOutras)
                    ).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>
      </div>
    </form>
  );
};
export default ExecucaoReceitaDespesa;
